import { Route, Routes, Link } from "react-router-dom";
import AuthGate from "./components/AuthGate";
import { signOut } from "./lib/api";
import PaperSelection from "./screens/PaperSelection";
import Reviewer from "./screens/Reviewer";

export default function App() {
  return (
    <div className="flex h-screen flex-col">
      <header className="flex items-center justify-between border-b border-ink-200 bg-white px-4 py-2 text-sm">
        <div>
          <Link to="/" className="font-semibold text-ink-900 hover:text-ink-700">
            Review Assistant
          </Link>
          <span className="ml-2 text-ink-500">
            code review and reproducibility audits
          </span>
        </div>
        <button
          onClick={() => void signOut()}
          className="rounded px-2 py-0.5 text-xs text-ink-500 hover:bg-ink-50 hover:text-ink-700"
          title="Sign out"
        >
          Sign out
        </button>
      </header>
      <main className="flex-1 overflow-hidden">
        <AuthGate>
          <Routes>
            <Route path="/" element={<PaperSelection />} />
            <Route path="/p/:egusphereId" element={<Reviewer />} />
          </Routes>
        </AuthGate>
      </main>
    </div>
  );
}
